import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/mit-stil-verzichten-vorstellungsgespraech-absagen.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')